import { Component, OnInit, Input } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { Product } from 'src/app/models/interface/product/product';

@Component({
  selector: 'app-product-tabs',
  templateUrl: './product-tabs.component.html',
  styleUrls: ['./product-tabs.component.scss']
})
export class ProductTabsComponent implements OnInit {

  @Input() item: Product;
  @Input() params: any;
  @Input() isps: any[];

  constructor() {
  }

  ngOnInit() {
  }

}
